import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/customer_accounts'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      name: null,
      surname: null,
      email: null,
      phone: null,
      phone_region_code: 90,
      phone_region_iso2: 'TR',
      password: null,
      id_customers: null,
      email_information: '1',
      email_subject: 'Hesap Bilgileriniz',
      email_body: 'Hesap bilgileriniz',
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    emailControl: {
      status: null,
      id: null,
    },
    filterData: {
      id_sectors: [],
      id_activities: [],
      id_meets: null,
      id_countries: null,
      id_cities: null,
    },
    search: {
      keyword: null,
    },
    detailForm: false,
    detailSearch: false,
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    emailControl(state) {
      return state.emailControl
    },
    detailForm(state) {
      return state.detailForm
    },
    detailSearch(state) {
      return state.detailSearch
    },
    filterData(state) {
      return state.filterData
    },
    search(state) {
      return state.search
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    SET_EMAIL_CONTROL(state, data) {
      state.emailControl = data
    },
    SET_DETAIL_FORM(state, data) {
      state.detailForm = data
    },
    SET_DETAIL_SEARCH(state, data) {
      state.detailSearch = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        name: null,
        surname: null,
        email: null,
        phone: null,
        phone_region_code: 90,
        phone_region_iso2: 'TR',
        password: null,
        id_customers: null,
        email_information: '1',
        email_subject: 'Hesap Bilgileriniz',
        email_body: 'Hesap bilgileriniz',
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'customer_accounts.id': id,
        },
        array: false,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    /* Custom */
    emailControl({ commit }, params) {
      return axiosIns
        .post(`${ROOT_URL}/emailControl`, params)
        .then(response => {
          commit('SET_EMAIL_CONTROL', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
  },
}
